// extracted by mini-css-extract-plugin
export default {"spinner":"LoaderElement_spinner__otthi"};